import { Field, inputCls } from './fields';

export default function ApplyStepKyc({ a, form, set, errors }) {
  const f = (key, testid, opts = {}) => (
    <input
      data-testid={`step-2-${testid}-input`}
      className={inputCls}
      value={form[key]}
      onChange={(e) =>
        set(key, opts.upper ? e.target.value.toUpperCase() : opts.number ? e.target.value.replace(/\D/g, '') : e.target.value)
      }
      placeholder={opts.placeholder || ''}
      inputMode={opts.number ? 'numeric' : undefined}
      maxLength={opts.maxLength}
      aria-label={opts.label}
    />
  );

  return (
    <div className="space-y-6" data-testid="apply-step-2">
      <Field label={a.name} testid="step-2-name" error={errors.full_name}>
        {f('full_name', 'name', { placeholder: 'Aarav Sharma' })}
      </Field>

      <div className="grid gap-6 sm:grid-cols-2">
        <Field label={a.phone} testid="step-2-phone" error={errors.phone}>
          {f('phone', 'phone', { number: true, maxLength: 10, placeholder: '98765 43210' })}
        </Field>
        <Field label={a.email} testid="step-2-email" error={errors.email}>
          {f('email', 'email', { placeholder: 'you@example.com' })}
        </Field>
      </div>

      <Field label={a.employment} testid="step-2-employment">
        <select
          data-testid="step-2-employment-select"
          className={inputCls}
          value={form.employment_type}
          onChange={(e) => set('employment_type', e.target.value)}
        >
          {a.employments.map((o) => (
            <option key={o} value={o} className="bg-ink">
              {o}
            </option>
          ))}
        </select>
      </Field>

      <div className="grid gap-6 sm:grid-cols-2">
        <Field label={a.income} testid="step-2-income" error={errors.monthly_income}>
          {f('monthly_income', 'income', { number: true, maxLength: 8, placeholder: '45000' })}
        </Field>
        <Field label={a.salaryDate} testid="step-2-salary-date" error={errors.salary_date}>
          {f('salary_date', 'salary-date', { number: true, maxLength: 2, placeholder: '1' })}
        </Field>
      </div>

      <div className="grid gap-6 sm:grid-cols-2">
        <Field label={a.pan} testid="step-2-pan" error={errors.pan_number}>
          {f('pan_number', 'pan', { upper: true, maxLength: 10, placeholder: 'ABCDE1234F' })}
        </Field>
        <Field label={a.aadhaar} testid="step-2-aadhaar" error={errors.aadhaar_last4}>
          {f('aadhaar_last4', 'aadhaar', { number: true, maxLength: 4, placeholder: '4821' })}
        </Field>
      </div>

      <Field label={a.city} testid="step-2-city">
        {f('city', 'city', { placeholder: 'Mumbai' })}
      </Field>
    </div>
  );
}
